// the endpoint's base url
let base_path = `/api/v2/contacts`

export default {
    /**
     * APIv2 endpoint for fetching contact details.
     *
     * @param contactId
     *
     * @handler Api/V2/Contacts/@index
     *
     * @return Promise
     */
    getContact(contactId) {
        return axios.get(`${base_path}/${contactId}`)
    },
}
